// i18n area 'vms' — locale pl-PL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.pl-PL.meta.json.
import type { enUS } from './vms'

export const plPL: typeof enUS = {
  vms: {
    spof: {
      title: 'Niezależność od węzła',
      single: 'Pojedynczy punkt awarii',
      alternativesNow: 'Alternatywy teraz',
      structural: 'Z konstrukcji',
      binding: 'Wiążące ograniczenie',
      movableNow: 'Migracja możliwa teraz',
    },
    title: 'Maszyny wirtualne',
    migratingChip: 'Migracja w toku',
    templateChip: 'Template',
    expendableTooltip: 'W klastrze zdegradowanym jest wśród pierwszych do zatrzymania i może nie uruchomić się ponownie po utracie węzła.',
    expendableHaTooltip: 'Zawsze uruchamiana ponownie, dopóki klaster jest zdrowy; w klastrze zdegradowanym maszyny chronione mają pierwszeństwo — może zostać zatrzymana lub pozostać wyłączona, aż klaster znów będzie cały, potem wraca sama.',
    viewDetails: 'Zobacz szczegóły',
    profileLegacy: 'Inny OS',
    hugePagesNone: 'Brak — zwykła pamięć',
    hugePages2M: 'Strony 2 MiB',
    hugePages1G: 'Strony 1 GiB',
    searchPlaceholder: 'Szukaj po nazwie',
    name: 'Nazwa',

    // Terminologia UNA (#94a): faza nazywa się „Faza” wszędzie — stary klucz
    // 'state' umarł razem z polishem listy.
    vcpus: 'vCPU',
    memory: 'Pamięć',
    ipAddresses: 'Adresy IP',
    noIp: 'Brak IP',
    authorityNode: 'Authority',
    authorityNextStart: 'przypisywana przy następnym uruchomieniu',
    scope: 'Scope',
    empty: 'Brak maszyn wirtualnych',
    loadError: 'Nie można wczytać maszyn wirtualnych — czy backend TVirt jest osiągalny?',
    filterOverlay: 'sieć overlay',
    filterDisk: 'dysk',
    filterImage: 'obraz',
    filteredBy: 'Filtrowane wg: {kind}',
    filterPhase: 'Faza',
    filterProtection: 'Ochrona',
    filterAll: 'Wszystkie',
    filterScopePlaceholder: 'Filtruj po scope',
    filtersToggle: 'Filtry',
    scopeTree: {
      title: 'Scope',
      all: 'Cały klaster',
      noChildren: 'Brak podrzędnych scope',
      recursive: 'Uwzględnij podrzędne',
      collapse: 'Zwiń panel scope',
      up: 'Poziom wyżej',
      countTooltip: '{direct} VM w tym scope · {total} z podrzędnymi'
    },

    // Dwukrokowy picker ISO (#85): najpierw katalog, potem jego obrazy ISO.
    isoPicker: {
      catalog: 'Katalog',
      unknownCatalog: 'Poza widocznymi katalogami',
      noIsos: 'Brak gotowych obrazów ISO w tym katalogu'
    },
    actionsHeader: 'Akcje',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Sprzęt',
      tags: 'Tagi',
      age: 'Wiek',
      disk: 'dysk',
      disks: 'dyski',
      empty: 'Brak template — należy oznaczyć jako template wyłączoną VM albo sklonować VM jako template.',
      clone: 'Klonuj / wdróż',
      editTags: 'Edytuj tagi',

      // Runda K3 (#64): eksportuje template jako plik .tvtpl w katalogu.
      exportAction: 'Eksportuj do katalogu (.tvtpl)',
      exportTitle: 'Eksportuj do katalogu',
      exportSubmit: 'Eksportuj',
      exportError: 'Eksport się nie powiódł',
      exportHint: 'Template zostaje spakowany do archiwum .tvtpl (manifest sprzętu + każdy dysk spłaszczony do qcow2) jako nowy plik Template VM w wybranym katalogu. Karty NIC, nośniki CD/DVD i cloud-init nie podróżują — specyfikacja formatu wymienia każde świadome pominięcie.',
      exportName: 'Nazwa pliku',
      exportNameHint: 'Puste = <template>-export-<n>',
      exportStorageDefault: 'Storage metadanych template',

      // Import z katalogu (Luca 2026-08-03): wejście w pasku narzędzi karty
      // Template — backend K3/K4 pokrywa wszystkie formaty vm-template,
      // wybiera się PLIK (format podróżuje tylko do odczytu).
      importAction: 'Importuj z katalogu',
      importTitle: 'Importuj z katalogu',
      importHint: 'Plik Template VM w stanie ready z wybranego katalogu staje się template w ewidencji: format pliku (tvtpl, ova, ovf albo goły qcow2) sam decyduje o sposobie importu — wybiera się wyłącznie plik.',
      importFile: 'Plik katalogu',
      importFileHint: 'Importuje się tylko pliki w stanie ready — plik w trakcie uploadu nie nadaje się do importu',
      importNoFiles: 'Brak plików Template VM w stanie ready w tym katalogu — należy najpierw jakiś wysłać albo wyeksportować'
    },
    templateDetail: {
      quickDeploy: 'Zgodność z QuickDeploy',
      quickDeployNone: 'Niezadeklarowana',
      quickDeployHint: 'Zadeklaruj ją tylko wtedy, gdy obraz golden zawiera cloud-init (Linux) lub cloudbase-init po sysprep /generalize (Windows): platforma ufa deklaracji i nigdy nie zagląda do wnętrza gościa.',
      notFound: 'Nie znaleziono template',
      frozen: 'Konfiguracja sprzętu jest zamrożona: aby ją zmienić, należy przywrócić template do postaci VM. Nazwa, notatki i tagi pozostają edytowalne.',
      storage: 'Storage',
      size: 'Rozmiar',
      configTitle: 'Konfiguracja (zamrożona)',
      usbClasses: 'Wymagane klasy USB',
      gpuClasses: 'Wymagane klasy GPU'
    },
    sharedDisksTab: {
      title: 'Dyski współdzielone',
      sharing: 'Współdzielenie',
      sharingNone: 'Jedno podłączenie',
      sharingMultiwriter: 'Współdzielony zapis (multiwriter)',
      sharingReadonly: 'Współdzielony tylko do odczytu',
      usedBy: 'Używany przez',
      attachedTo: 'Podłączony do',
      notAttached: 'Niepodłączony do żadnej VM',
      changeSharing: 'Zmień tryb współdzielenia',
      changeSharingTitle: 'Tryb współdzielenia',
      changeSharingLocked: 'Tryb można zmienić tylko, gdy żadna VM nie używa dysku',
      sharingChanged: 'Tryb współdzielenia zaktualizowany.',
      lun: 'Cały LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Numer seryjny',
      antiAffinityWarning: 'Co najmniej dwaj członkowie działają na tym samym węźle bez reguły anty-afiniczności: awaria jednego węzła zatrzyma wszystkich',
      antiAffinityCreate: 'Utwórz regułę',
      createSourceLun: 'Przejmij cały LUN targetu',
      createLunNumber: 'Numer LUN (id namespace w NVMe)',
      createLunHint: 'Nic nie jest przydzielane: rozmiar odczytuje się z urządzenia przy przejęciu',
      noPr: 'W tym wydaniu nie ma SCSI-3 persistent reservations: Windows Failover Cluster z klasycznym dyskiem współdzielonym nie jest zwalidowany; klastry koordynujące się przez sieć (GFS2/OCFS2, RHEL HA, bazy shared-disk) tak'
    },
    unusedDisksTab: {
      title: 'Nieużywane dyski',
      attach: 'Podłącz do VM',
      attachTitle: 'Podłącz do VM',
      vm: 'Maszyna wirtualna',
      noVms: 'Brak dostępnych VM',
      noSlots: 'Brak wolnego slotu na tej VM',

      // Utwórz samodzielny dysk (#87): wrócił z emerytowanego Inwentarza, teraz
      // z JAWNYM polem scope (nie ma VM, po której można by je odziedziczyć).
      create: 'Utwórz dysk',
      createTitle: 'Utwórz dysk',
      createSourceBlank: 'Pusty dysk',
      createSourceImage: 'Z obrazu w katalogu',
      createImage: 'Obraz',
      createImageEmpty: 'Brak gotowego obrazu szablonu VM w widocznych katalogach',
      createSizeFromImageHint: 'Wstępnie wypełnione wirtualnym rozmiarem obrazu — może tylko rosnąć',

      // #107 (DESTRUKCYJNE, ratyfikowane): qcow2 → plik katalogu vm-template
      // na tym samym storage, zero skopiowanych bajtów — dysk przestaje istnieć.
      convert: 'Konwertuj na template VM…',
      convertOnlyQcow2: 'Konwertuje się wyłącznie dyski qcow2 — raw nie jest rejestrowalnym formatem template',
      convertTitle: 'Konwertuj na template VM',
      convertSubmit: 'Konwertuj (niszczy dysk)',
      convertError: 'Nie można uruchomić konwersji',
      convertWarning: 'DESTRUKCYJNE: dysk staje się plikiem template VM w wybranym katalogu — ten sam storage, zero skopiowanych bajtów — i PRZESTAJE ISTNIEĆ jako dysk. Odwrotu nie ma, poza utworzeniem nowego dysku z template.',
      convertNameHint: 'Nazwa pliku katalogu — domyślnie nazwa dysku',
      convertConfirm: 'Rozumiem: dysk zostanie zniszczony',
      convertStarted: 'Konwersja uruchomiona — template pojawi się w katalogu po zamknięciu taska.',
      storageLockHint: 'Zmienia się tylko akcją Przenieś',
      source: 'Pochodzenie',
      sourceClone: 'Klon innego dysku',
      sourceCloneLinked: 'Linked clone innego dysku',
      sourceImage: 'Utworzony z obrazu',
      sourceBlank: 'Utworzony pusty',
      allocated: 'Zaalokowane / rozmiar wirtualny',
      observedAt: 'Zaobserwowano',
      snapshots: 'Snapshoty',
      snapshotsEmpty: 'Brak snapshotów'
    },
    phase: {
      defined: 'Nigdy nieuruchomiona',
      starting: 'Uruchamianie',
      running: 'Działa',
      stopping: 'Zatrzymywanie',
      stopped: 'Zatrzymana',
      paused: 'Wstrzymana',
      failed: 'Błąd',
      deleting: 'Usuwanie'
    },
    stopCause: {
      'api': 'Zatrzymana przez TVirt (akcja albo API)',
      'guest-shutdown': 'Wyłączenie zainicjowane przez system operacyjny gościa',
      'crash': 'Awaria systemu gościa',
      'qemu-exit': 'Proces QEMU zakończył się nieoczekiwanie',
      'host-reboot': 'Węzeł został zrestartowany',
      'migrated': 'Zmigrowana na inny węzeł',
      'fenced': 'Zakończona przez fencing HA (węzeł wrócił)'
    },
    detail: {
      notFound: 'Nie znaleziono maszyny wirtualnej',
      details: 'Szczegóły',
      id: 'ID',
      scope: 'Scope',
      profile: 'Profil sprzętowy',
      firmware: 'Firmware',
      firmwareFile: 'Wersja firmware UEFI',
      firmwareUpdate: 'Dostępna aktualizacja',
      firmwareUpdateHint: 'Platforma dostarcza nowszy firmware UEFI. Aktualizacja nigdy nie jest automatyczna: stosuje się ją przy wyłączonej VM, kiedy sam zdecydujesz.',
      arch: 'Architektura',
      node: 'Węzeł',
      bootOrder: 'Kolejność rozruchu',
      agent: 'Stan agenta',
      agentConnected: 'Połączony',
      agentNotConnected: 'Niepołączony',
      protected: 'Chroniona',
      linkedClones: 'Klony powiązane',
      restartPolicy: 'Polityka restartu',
      preferredNode: 'Preferowany węzeł',
      noPreference: 'Brak preferencji (automatyczny placement)',
      preferNodes: 'Preferowane tagi węzła',
      requireNodes: 'Wymagane tagi węzła',
      noPlacementTags: 'Brak',
      placementTag: 'Tag',
      placementValue: 'Wartość',
      placementAddTag: 'Dodaj tag',
      proximityHa: 'HA w TVirt Proximity',
      proximityHaRestarts: 'restarty HA',
      proximityHaGaveUp: 'pętla awarii — HA się poddało',
      failoverProtection: 'Ochrona w klastrze zdegradowanym',
      protectionProtected: 'Chroniona',
      protectionExpendable: 'Do poświęcenia przy degradacji',
      protectionInherit: 'Dziedzicz',
      lastStop: 'Ostatnie zatrzymanie',
      yes: 'Tak',
      no: 'Nie',
      tabOverview: 'Przegląd',
      tabSnapshots: 'Snapshoty',
      tabBackups: 'Kopie',
      hardware: 'Sprzęt',
      name: 'Nazwa',
      hwSystem: 'System',
      hwCpu: 'CPU',
      hwMemory: 'Pamięć',
      hwBoot: 'Rozruch',
      hwIdentity: 'Tożsamość',
      hwCluster: 'Klaster i agent',
      cpuTopology: 'Topologia CPU',
      cpuModel: 'Model CPU',
      cpuLimit: 'Limit CPU',
      cpuWeight: 'Waga CPU',
      cpuNested: "Wirtualizacja zagnieżdżona",
      cpuNestedHint: "Udostępnia gościowi vmx/svm (tylko z modelem CPU host). Na działającej VM zmiana obowiązuje od następnego power cycle (PendingRestart); rozmieszczenie dopuszcza tylko węzły z włączonym nested.",
      unlimited: 'Bez ograniczeń',
      memory: 'Pamięć',
      balloon: 'Balloon',
      hugePages: 'Ogromne strony',
      hugePagesTradeoff: 'Mniej pracy przy tłumaczeniu adresów i pamięć, która nigdy nie trafia na dysk; w zamian rezerwacja zostaje przypięta do węzła, dopóki VM działa, pamięć nie jest już deduplikowana, a uruchomienie kończy się błędem, jeśli węzeł ma za mało wolnych stron.',
      disks: 'Dyski',
      cdroms: 'Napędy CD/DVD',
      nics: 'Interfejsy sieciowe',
      slot: 'Slot',
      disk: 'Dysk',
      encrypted: 'Szyfrowany',
      image: 'Obraz',
      emptyDrive: 'Pusty napęd',
      emptyOption: '(pusty)',
      network: 'Sieć',
      mac: 'MAC',
      connected: 'Podłączona',
      unplugged: 'Odłączona',
      noDevices: 'Brak',
      screenshot: 'Zrzut ekranu',
      capturedAt: 'Wykonano o',
      noCapture: 'Brak zrzutu',
      snapshotName: 'Nazwa',
      snapshotCreated: 'Utworzono',
      snapshotMemory: 'Pamięć dołączona',
      noSnapshots: 'Brak snapshotów',
      pendingRestart: 'Zmiany oczekujące: zostaną zastosowane przy następnym power cycle.',
      applied: 'zastosowana',
      appliedHint: 'VM działa z tą wartością — skonfigurowana obowiązuje od następnego power cycle.',
      actionError: 'Akcja się nie powiodła',
      actionStillRunning: 'Akcja wciąż trwa — wynik nie jest jeszcze znany',
      tabConsole: 'Konsola',
      consoleConnect: 'Połącz',
      consoleDisconnect: 'Rozłącz',
      consoleConnecting: 'Łączenie…',
      consoleReconnecting: 'Łączenie…',
      consoleUnavailable: 'Konsola jest dostępna, gdy VM działa albo jest wstrzymana.',
      consoleError: 'Połączenie z konsolą się nie powiodło',
      consoleTaken: 'Sesja konsoli przejęta przez {user}',
      consoleReconnect: 'Połącz ponownie',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Przytrzymaj {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Otwórz na pełnym ekranie w nowej karcie',
      consoleLoadFailed: 'Nie znaleziono VM albo brak uprawnień',
      consoleClose: 'Zamknij',
      tabStats: 'Statystyki',
      tabTasks: 'Taski',
      tabLogs: 'Logi',
      statsCpu: 'CPU',
      statsMemory: 'Pamięć',
      statsDisk: 'I/O dysku',
      statsRange: 'Przedział',
      statsNoData: 'Brak danych w tym przedziale — statystyki są próbkowane, gdy VM działa.',
      statsError: 'Nie można wczytać statystyk',
      cpuUsage: 'Wykorzystanie',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Użyta',
      memGuestAvailable: 'Dostępna (gość)',
      schema: 'Schemat',
      consoleProtocol: 'Konsola',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Storage metadanych',
      startupOnBoot: 'Autostart przy rozruchu',
      startupOrder: 'Kolejność uruchamiania',
      startupDelay: 'Opóźnienie uruchomienia',
      seconds: 's',
      enabled: 'Włączone',
      disabled: 'Wyłączone'
    },
    actionsAvailable: 'Dostępne akcje',
    actions: {
      start: 'Uruchom',
      stop: 'Zatrzymaj',
      pause: 'Wstrzymaj',
      resume: 'Wznów',
      reset: 'Zresetuj',
      migrate: 'Migruj',
      clone: 'Klonuj',
      moveStorage: 'Przenieś na storage…',
      moveScope: 'Przenieś do scope…',
      openConsole: 'Otwórz konsolę',
      forceStop: 'Wymuś wyłączenie',
      markTemplate: 'Oznacz jako template',
      unmarkTemplate: 'Przywróć do VM',
      error: 'Nie można wykonać akcji'
    },
    cordon: {
      confirmTitle: 'Węzeł jest w trybie konserwacji',
      confirmHint:
        'Kordonu nie da się opuścić, dopóki store klastra jest niedostępny. Potwierdzając, oświadczasz, że o tym wiesz: maszyna i tak się tam uruchomi, a zgoda zostanie zapisana na zadaniu.',
      confirm: 'Uruchom mimo to'
    },
    markTemplate: {
      confirmTitle: 'Oznaczyć {name} jako template?',
      confirmBody: 'Konfiguracja zostaje zamrożona, a VM nie będzie się już mogła uruchomić — tylko klonować albo wrócić do postaci VM. Nazwa, notatki i tagi pozostają edytowalne.',
      confirm: 'Oznacz jako template',
      moved: '{name} jest teraz template — przeniesiona do karty Template.'
    },
    unmarkTemplate: {
      confirmTitle: 'Przywrócić {name} do postaci VM?',
      confirmBody: 'Template wraca do postaci zwykłej VM: edytowalnej i uruchamialnej (następne uruchomienie rozmieszcza ją na węźle).',
      confirm: 'Przywróć do VM',
      moved: '{name} znów jest maszyną wirtualną — przeniesiona do karty Maszyny wirtualne.'
    },

    // Runda #123: odwołanie do węzła po TAGU (selektor #106) w dialogach
    // uruchamiania i migracji — z podglądem rozwiązanego zbioru.
    nodeByTag: {
      label: 'Według tagów węzła',
      hint: 'tag=wartość, rozdzielone przecinkami (łączone przez AND): decider wybiera spośród pasujących węzłów',
      invalid: 'Nieprawidłowy format — należy użyć tag=wartość, rozdzielonych przecinkami',
      resolved: 'Pasujący członkowie: {nodes}'
    },
    migrate: {
      title: 'Live migration',
      submit: 'Migruj',
      target: 'Węzeł docelowy',
      auto: 'Automatycznie (Proximity)',
      hint: 'VM przenosi się bez power cycle. Każdy storage, którego dotyka, musi być współdzielony; wstrzymana VM migruje jako wstrzymana.',
      error: 'Migracja została odrzucona'
    },
    moveStorage: {
      title: 'Przenieś na storage',
      submit: 'Przenieś',
      target: 'Storage docelowy',
      noTargets: 'Żaden storage nie przyjmuje dysków',
      hint: 'Wszystkie dyski wyłączonej VM wędrują na wybrany storage, jeden po drugim, zachowując swoje id — te, które już tam są, zostają pominięte. Postęp żyje na stronie tasków.',
      error: 'Przeniesienie zostało odrzucone'
    },
    moveScope: {
      title: 'Przenieś do scope',
      submit: 'Przenieś',
      target: 'Scope docelowy',
      hint: 'VM zmienia scope natychmiast — id i dyski zostają, dyski będące jej własnością podążają za nią, a ona sama może pozostać uruchomiona. Dziś żyje w {scope}. Wraz ze scope zmienia się to, kto ją widzi.',
      error: 'Przeniesienie do innego scope zostało odrzucone'
    },
    start: {
      title: 'Uruchom VM',
      submit: 'Uruchom',
      target: 'Węzeł docelowy',
      auto: 'Automatycznie (zalecane)',
      recommended: 'zalecany',
      hint: 'Można wybrać węzeł docelowy albo pozostawić decyzję Proximity spośród prawidłowych kandydatów. Węzły, które nie mogą jej przyjąć, są wyłączone wraz z podanym powodem.',
      error: 'Nie można uruchomić VM'
    },
    console: {
      media: 'Napędy CD/DVD',
      mediaGuestToolsHint: 'Zawiera TVirt Guest Tools — stąd można je wysunąć albo usunąć napęd',
      slotOpsDeferred: 'W tym profilu dodanie i usunięcie napędu obowiązują od następnego power cycle (zmiany nośnika są natychmiastowe).',
      mountGuestTools: 'Zamontuj TVirt Guest Tools',
      ejectGuestTools: 'Wysuń TVirt Guest Tools',
      bootOrder: 'Kolejność rozruchu',
      bootOrderHint: 'Nowa kolejność zapisuje się od razu i obowiązuje od następnego power cycle — sesja konsoli pozostaje połączona.'
    },
    snapshots: {
      create: 'Utwórz snapshot',
      createTitle: 'Utwórz snapshot',
      createSubmit: 'Utwórz',
      name: 'Nazwa',
      nameHint: 'Litery, cyfry, kropka, myślnik, podkreślenie.',
      consistencyHint: 'Spójność jest automatyczna: guest agent zamraża systemy plików, kiedy odpowiada; w przeciwnym razie VM zostaje na moment wstrzymana wokół snapshotu.',
      memory: 'Dołącz pamięć',
      memoryHint: 'Przechwytuje żywą RAM: przywrócenie wznawia VM w trakcie działania. Wymaga wszystkich dysków w qcow2.',
      currentChip: 'Jesteś tutaj',
      revert: 'Przywróć',
      revertTitle: 'Przywrócić {name}?',
      revertBody: 'Dyski wracają do stanu ze snapshotu; wszystko, co wydarzyło się później, zostaje utracone. Snapshot bez pamięci wymaga zatrzymanej VM.',
      delete: 'Usuń',
      deleteTitle: 'Usunąć snapshot {name}?',
      deleteBody: 'Punkt przywracania znika; zawartość dysków pozostaje nietknięta.',
      deleteMergeHint: 'Jego delta scala się w {children}: każdy późniejszy punkt przywracania pozostaje ważny.',
      deleteDuplication: 'Akceptuję duplikację',
      deleteDuplicationHint: 'Delta jest kopiowana do każdego z {count} czytelników (snapshoty potomne oraz, jeśli ten jest bieżący, aktywna głowica): zajęte miejsce może rosnąć zamiast maleć.',
      error: 'Operacja na snapshocie została odrzucona'
    },
    clone: {
      title: 'Klonuj VM',
      submit: 'Klonuj',
      name: 'Nazwa kopii',
      storage: 'Storage docelowy dysków',
      sameStorage: 'Ten sam co źródłowy',
      full: 'Pełna kopia',
      fullHint: 'Kopiuje każdy bajt i zrywa więź z dyskami źródłowymi. Domyślnie wykonywany jest linked clone: natychmiastowy, ale przykuty do źródła (tylko qcow2).',
      hint: 'Klon zachowuje konfigurację i firmware źródła; adresy MAC i tożsamość TPM są nowe.',
      markAs: 'Typ klona',
      markAsInheritVm: 'Jak źródło (VM)',
      markAsInheritTemplate: 'Jak źródło (template)',
      markAsVm: 'Maszyna wirtualna',
      markAsTemplate: 'Template',
      markAsHintVm: 'Wybór opcji Template promuje kopię w jednym kroku.',
      markAsHintTemplate: 'Wybór opcji Maszyna wirtualna wdraża z tego template w jednym kroku.',
      error: 'Klonowanie zostało odrzucone'
    },
    bulk: {
      selected: 'zaznaczonych',
      deleteTitle: {
        one: 'Usunąć zaznaczoną VM ({count})?',
        few: 'Usunąć zaznaczone VM ({count})?',
        many: 'Usunąć zaznaczone VM ({count})?',
        other: 'Usunąć zaznaczone VM ({count})?'
      },
      deleteBody: 'Każda VM przechodzi te same bramki co przy pojedynczym usunięciu; odmowy są raportowane dla każdego elementu.',
      done: 'przyjęte',
      refused: 'odrzucone'
    },
    delete: {
      button: 'Usuń',
      confirmTitle: 'Usunąć {name}?',
      confirmBody: 'Maszyna wirtualna i dyski będące jej własnością zostaną usunięte. Operacja jest nieodwracalna.',
      keepDisks: 'Zachowaj dyski',
      keepDisksHint: 'Dyski utworzone razem z VM zostają na swoim storage jako dyski samodzielne.',
      confirm: 'Usuń',
      cancel: 'Anuluj',
      error: 'Usunięcie się nie powiodło',
      blockedPhase: 'Najpierw trzeba zatrzymać VM',
      blockedProtected: 'VM jest chroniona — należy najpierw zdjąć ochronę',
      blockedDeleting: 'Usuwanie już trwa'
    },
    logs: {
      title: 'Logi',
      subtitle: 'Strukturalne ramki logów z tasków dotykających tej VM',
      when: 'Kiedy',
      task: 'Task',
      level: 'Poziom',
      message: 'Komunikat',
      empty: 'Jeszcze brak logów',
      loadError: 'Nie można wczytać logów — czy backend TVirt jest osiągalny?'
    },
    stop: {
      title: 'Zatrzymaj maszynę wirtualną',
      modeGraceful: 'Wyłączenie graceful',
      modeGracefulHint: 'System operacyjny gościa zostaje poproszony o naturalne wyłączenie (ACPI); jeśli zignoruje prośbę, po upływie timeoutu następuje wymuszone wyłączenie.',
      modeForced: 'Wymuszone wyłączenie',
      modeForcedHint: 'Odcina zasilanie natychmiast, jak wyjęcie wtyczki z gniazdka.',
      timeout: 'Timeout awaryjny (sekundy)',
      timeoutHint: 'Czas dany gościowi przed wymuszeniem wyłączenia'
    },

    // Menu przycisku split tworzenia (Luca 2026-07-23): „Od zera” otwiera
    // kreator, pozostałe dwie pozycje to stuby roadmapy.
    createFromScratch: 'Od zera',
    createFromTemplate: 'Z template',
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Wykonaj deploy',
      error: 'Deploy nie powiódł się',
      compatNote: 'QuickDeploy wymaga szablonu zgodnego z QuickDeploy: platforma dostosowuje gościa (sieć, domena, aktywacja) przy pierwszym uruchomieniu.',
      template: 'Szablon',
      noTemplates: 'Żaden szablon nie deklaruje jeszcze zgodności z QuickDeploy — zadeklaruj ją w zakładce Szablony (Linux z cloud-init, Windows z cloudbase-init po sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Nazwa hosta',
      hostnameHint: 'Nazwa hosta lub FQDN; puste = nazwa VM (Windows: najwyżej 15 znaków)',
      ip: 'Adres IP',
      ipHint: 'Host i prefiks, np. 192.168.122.101/24; puste = DHCP',
      gateway: 'Brama',
      dns: 'Serwery DNS',
      dnsHint: 'Do trzech, rozdzielone przecinkami',
      count: 'Instancje',
      countHint: 'Więcej niż jedna: nazwane <nazwa>-1…-N, tylko DHCP',
      user: 'Użytkownik',
      userHint: 'Puste = domyślny użytkownik obrazu (Linux) lub Administrator (Windows)',
      password: 'Hasło',
      passwordHint: 'Zapisywane w wygenerowanym user-data, które platforma następnie deklaruje jako tajne: nikt go już nie odczyta',
      sshKeys: 'Klucze publiczne SSH',
      sshKeysHint: 'Jeden na wiersz (ssh-ed25519 AAAA… komentarz)',
      productKey: 'Klucz produktu Windows',
      kmsServer: 'Serwer KMS',
      kmsHint: 'Host lub host:port — wymaga klucza produktu (klucza klienta KMS)',
      adDomain: 'Dołącz do domeny Active Directory',
      adDomainHint: 'Puste = bez dołączania do domeny',
      adUser: 'Konto dołączające',
      adPassword: 'Hasło konta dołączającego',
      adOu: 'Docelowa OU (opcjonalnie)',
      advanced: 'Zaawansowane: surowe dokumenty',
      userData: 'user-data (surowe)',
      userDataHint: 'Zastępuje wygenerowane user-data: użytkownik, hasło, klucze i pola Windows powyżej muszą pozostać puste',
      networkConfig: 'network-config (surowe)',
      networkConfigHint: 'Zastępuje wygenerowaną sieć: IP, brama i DNS powyżej muszą pozostać puste',
      secret: 'Traktuj surowe user-data jako tajne',
      secretHint: 'Oznaczone jako tajne przestaje być zwracane przez API komukolwiek i podróżuje w Checkpoincie zapieczętowane masterpass',
      startNow: 'Uruchom od razu',
      startNowHint: 'Każda instancja uruchamia się zaraz po zdefiniowaniu; seed powstaje przy tym uruchomieniu'
    },

    create: {
      nicAttachmentNetwork: 'Sieć logiczna (fabric)',
      nicNetwork: 'Sieć logiczna',
      nicNetworkHint: 'ZALECANA droga (F3): vNIC realizuje się na WYPROWADZONYM bridge\'u obsługującego węzła — bridge rodzi się przy jawnym apply fabric, a start na węźle, który go jeszcze nie nosi, odmawia mówiąc. Gdy ostatnia referencja floty odchodzi, bridge wypada przy następnym apply.',
      button: 'Utwórz VM',
      title: 'Utwórz maszynę wirtualną',
      dialogTitle: 'Utwórz maszynę wirtualną',
      stepGeneral: 'Ogólne',
      stepGeneralHint: 'Nazwa i profil',
      stepCompute: 'CPU i RAM',
      stepComputeHint: 'Topologia i rozmiary',
      stepDisks: 'Dyski',
      stepDisksHint: 'Utwórz albo podłącz',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Napędy i nośniki',
      stepNetwork: 'Sieć',
      stepNetworkHint: 'NIC: trunk albo bridge',
      stepSummary: 'Podsumowanie',
      stepSummaryHint: 'Sprawdź i utwórz',
      name: 'Nazwa',
      nameHint: 'Małe litery, cyfry i myślniki (DNS-1123)',
      nextButton: 'Dalej',
      prevButton: 'Wstecz',
      submitButton: 'Utwórz',
      creating: 'Tworzenie…',
      sockets: 'Sockety',
      cores: 'Rdzenie na socket',
      threads: 'Wątki na rdzeń',
      totalVcpus: 'vCPU łącznie',
      memoryGib: 'Pamięć (GiB)',
      cpuModelHint: "'host' udostępnia CPU hosta",
      cpuLimitHint: 'Sufit w rdzeniach hosta — puste = bez ograniczeń',
      cpuNestedHint: "Udostępnia gościowi vmx/svm, by mógł uruchomić własny hiperwizor — wymaga modelu CPU host i węzła z włączonym nested",
      newDisk: 'Nowy dysk',
      attachDisk: 'Podłącz istniejący dysk',
      diskStorage: 'Storage',
      diskSize: 'Rozmiar (GiB)',
      diskSelect: 'Dysk',
      addDisk: 'Dodaj dysk',
      addCdrom: 'Dodaj napęd CD/DVD',
      addNic: 'Dodaj interfejs sieciowy',
      remove: 'Usuń',
      slotLimit: 'Osiągnięto limit slotów',
      cdromImage: 'Obraz (pusty napęd, jeśli brak)',
      nicAttachment: 'Podłączenie',
      nicAttachmentTrunk: 'Trunk overlay',
      nicAttachmentBridge: 'Bridge hosta',
      nicUntagged: 'Overlay untagged',
      nicUntaggedNone: 'Brak (tylko tagged)',
      nicTrunkHint: 'Przynajmniej jedna strona: overlay untagged i/albo mapowania VLAN tagged — VM może działać wyłącznie na hostach zadeklarowanych przez każdą przywołaną sieć overlay',
      nicTaggedVlan: 'ID VLAN',
      nicTaggedOverlay: 'Sieć overlay',
      addTagged: 'Dodaj VLAN tagged',
      nicBridge: 'Nazwa bridge’a hosta',
      nicBridgeHint: 'Bridge NM po nazwie — VM może działać wyłącznie na serwerach, których sieć hosta deklaruje ten bridge',
      nicMac: 'MAC (automatycznie, jeśli puste)',
      noDisksHint: 'Brak dysków: VM będzie miała wyłącznie dodane napędy CD/DVD.',
      noCdromsHint: 'Brak napędu CD/DVD: należy dodać jeden, aby uruchomić system z obrazu ISO.',
      mountGuestTools: 'Zamontuj TVirt Guest Tools przy pierwszym uruchomieniu',
      mountGuestToolsHint: 'Wkłada ISO ze sterownikami virtio i guest agentem do pustego napędu CD (dodanego w razie potrzeby) — instalator Windows potrzebuje go, aby zobaczyć dyski.',
      noNicsHint: 'Brak interfejsu sieciowego: VM uruchomi się bez łączności.',
      taggedMappings: 'Mapowania VLAN tagged',
      summaryDevices: 'Urządzenia',
      bootOrderTitle: 'Kolejność rozruchu',
      bootOrderHint: 'Przeciąganie zmienia kolejność — wygrywa pierwsze urządzenie zdolne do rozruchu; karty NIC startują przez PXE',
      bootOrderUp: 'Przesuń w górę',
      bootOrderDown: 'Przesuń w dół',
      createError: 'Utworzenie się nie powiodło'
    },
    edit: {
      button: 'Edytuj',
      title: 'Edytuj maszynę wirtualną',
      cancel: 'Anuluj',
      save: 'Zapisz',
      error: 'Zmiana się nie powiodła',
      modelStoppedOnly: 'Edytowalne tylko przy wyłączonej VM',
      firmwareStoppedOnly: 'Firmware edytowalny tylko przy wyłączonej VM — przy następnym uruchomieniu maszyna startuje z nowym firmware, a zmienne UEFI zostają',
      hugePagesStoppedOnly: 'Edytowalne tylko przy wyłączonej VM — przy następnym uruchomieniu pamięć rodzi się na nowym podłożu',
      runningHint: 'Zmiany obowiązują od następnego power cycle',
      sectionCpu: 'CPU',
      sectionMemory: 'Pamięć',
      sectionPolicy: 'Polityki'
    },
    devices: {
      networkChip: 'sieć fabric',
      title: 'Urządzenia',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Dodaj urządzenie USB',
      addUsbTitle: 'Zażądaj klasy urządzeń USB',
      usbClassHint:
        'VM prosi o KLASĘ urządzeń USB (wartość taga usb-device), nigdy o konkretne urządzenie: przy starcie na węźle zostaje wybrane i zarezerwowane konkretne wolne urządzenie. Zarejestrowane urządzenia taguje się w Klaster › Zasoby USB i PCIe.',
      usbTag: 'Tag (usb-device)',
      usbValue: 'Wartość klasy',
      noUsbTags: 'Brak taga usb-device — należy go utworzyć i otagować zarejestrowane urządzenia w Klaster › Zasoby USB i PCIe.',
      noUsbValues: 'Ten tag nie ma jeszcze zadeklarowanych wartości.',
      usbEmpty: 'Brak wymagań USB — dodanie klasy pozwala przekazać urządzenie przy starcie.',
      usbClassChip: 'klasa',
      usbPortChip: 'port',
      usbUnclaimed: 'Brak zarezerwowanego urządzenia — rozstrzyga się przy starcie VM.',
      addGpu: 'Dodaj GPU',
      addGpuTitle: 'Zażądaj klasy GPU',
      gpuClassHint:
        'VM prosi o KLASĘ GPU (wartość taga gpu-device), nigdy o konkretną kartę: przy starcie konkretna wolna karta zostaje wybrana i zarezerwowana na węźle, a RAZEM z nią przechodzi cała jej grupa IOMMU. Zarejestrowane GPU taguje się w Klaster › Zasoby USB i PCIe.',
      gpuTag: 'Tag (gpu-device)',
      gpuValue: 'Wartość klasy',
      noGpuTags: 'Brak taga gpu-device — należy go utworzyć i otagować zarejestrowane GPU w Klaster › Zasoby USB i PCIe.',
      noGpuValues: 'Ten tag nie ma jeszcze zadeklarowanych wartości.',
      gpuEmpty: 'Brak wymagań GPU — dodanie klasy pozwala przekazać kartę przy starcie.',
      gpuClassChip: 'klasa',
      gpuGroupChip: 'grupa IOMMU ×',
      gpuUnclaimed: 'Brak zarezerwowanej karty — rozstrzyga się przy starcie VM.',
      gpuPowerCycle: 'Brak hotplugu GPU — zmiany obowiązują od następnego power cycle (PendingRestart)',
      actions: 'Akcje',
      attachDisk: 'Dodaj dysk',
      attachDiskTitle: 'Dodaj dysk',
      attach: 'Podłącz',
      noFreeDisks: 'Brak nieużywanych dysków — należy jakiś utworzyć w Maszyny wirtualne › Nieużywane dyski.',
      addCdrom: 'Dodaj napęd',
      addCdromTitle: 'Dodaj napęd CD/DVD',
      editCdromTitle: 'Zmień obraz CD/DVD',
      changeMedia: 'Zmień obraz CD/DVD',
      ejectMedium: 'Wysuń',
      mountGuestTools: 'Zamontuj TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools zamontowane',
      guestToolsClickMount: 'Wkłada ISO TVirt Guest Tools do pierwszego pustego napędu CD/DVD',
      guestToolsClickUnmount: 'Kliknięcie wysuwa nośnik — napęd zostaje, pusty',
      guestToolsNoSlot: 'Brak pustego napędu CD/DVD — należy dodać napęd (albo wysunąć nośnik), aby zamontować TVirt Guest Tools',
      guestToolsSkew: 'Zamontowano v{pinned}; węzeł {node} udostępnia teraz v{current}: wysuń i zamontuj ponownie, aby zaktualizować',
      ejectGuestTools: 'Wysuń TVirt Guest Tools (napęd zostaje, pusty)',
      guestToolsEjectConfirmTitle: 'Wysunąć TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Nośnik zostaje wysunięty z uruchomionej VM — napęd CD/DVD zostaje, pusty.',
      applyLive: 'Zastosuj od razu (VM jest uruchomiona)',
      addNic: 'Dodaj interfejs',
      addNicTitle: 'Dodaj interfejs sieciowy',
      editNicTitle: 'Edytuj interfejs sieciowy',
      bridgeChip: 'bridge',
      cable: 'Kabel wirtualny',
      plug: 'Podłącz kabel wirtualny',
      unplug: 'Odłącz kabel wirtualny',
      remove: 'Usuń',
      removeTitle: 'Usunąć {device}?',
      removeBody: 'Przy uruchomionej VM zmiana obowiązuje od następnego power cycle. Dyski i obrazy są odłączane, nigdy usuwane.'
    }
  }
}
